<template>
  <div id="raft-js">
    <b-container v-if="showElement">
      <router-view
        @form-error-message="setError"
        @submit-form-data="submitFormData"
      />
    </b-container>
  </div>
</template>

<script>
import EntityFormHelper from "../../lib/EntityFormHelper";

export default {
  name: "BioMaterial",
  data() {
    return {
      error: null,
      message: null,
    };
  },
  computed: {
    showElement: function () {
      return this.error === null && this.message === null;
    },
  },
  methods: {
    reloadPage(event) {
      event.preventDefault();
      window.location.reload();
    },
    setError(error) {
      this.error = error.message;
      if (error?.data?.hasOwnProperty("errors")) {
        Object.keys(error.data.errors).forEach((key) => {
          const item = error.data.errors[key];
          if (item.hasOwnProperty("detail")) {
            this.error += " " + item.detail;
          }
        });
      }
    },
    submitFormData(message) {
      if (message) {
        this.$showNotification("info", message);
      } else {
        this.$showNotification(
          "success",
          "Biological material data submitted.",
        );
      }
      // @todo roche_work Make this is a generic element and allow the child element to pass in a message.
      EntityFormHelper.gotoDestination();
    },
  },
};
</script>

<style scoped>
#raft-js {
  font-size: 16px;
  font-size: var(--font-size-base, 16px);
  line-height: 1.25;
}

#raft-js >>> input,
#raft-js >>> select {
  font-size: var(--font-size-100, 1rem);
}

#raft-js >>> input[type="text"] {
  width: 50%;
}

#raft-js >>> .form-group label {
  margin-bottom: 0;
}

#raft-js >>> .form-row {
  margin-top: 1.5rem;
}

#raft-js >>> .field + .field {
  margin-top: 1rem;
}

#raft-js >>> h2 {
  margin-bottom: 1rem;
}
</style>
